module.exports = __webpack_public_path__ + "img/lg_ring_r_l_null_1@2x.cb464d55.png";